import { render, staticRenderFns } from "./CategoryLevel1Bar.vue?vue&type=template&id=97db51e2&scoped=true&"
import script from "./CategoryLevel1Bar.vue?vue&type=script&lang=js&"
export * from "./CategoryLevel1Bar.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLevel1Bar.vue?vue&type=style&index=0&id=97db51e2&prod&lang=scss&scoped=true&"
import style1 from "./CategoryLevel1Bar.vue?vue&type=style&index=1&id=97db51e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97db51e2",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QTabs,QTab,QImg,QBtn,QBadge});
